<template>
    <ModalContent>
        <Title>팩스전송 파일 선택</Title>

        <TimeInfo>
            <TimeItem>팩스(장당) : 75원</TimeItem>
        </TimeInfo>

        <ContentWrapper>
            <InfoRow>
                <label>발신번호:</label>
                <select v-model="senderNumber">
                    <option value="선택">선택</option>
                    <option value="0617250656">0617250656</option>
                </select>
            </InfoRow>

            <InfoRow>
                <label>팩스수신번호:</label>
                <input type="text" v-model="faxNumber" />
            </InfoRow>

            <InfoRow>
                <label>팩스제목:</label>
                <input type="text" v-model="faxTitle" style="width: 400px;" placeholder="팩스제목을 입력해주세요." />
            </InfoRow>
        </ContentWrapper>

        <CheckboxWrapper>
            <CheckboxGroup>
                <CustomCheckbox>
                    <input type="checkbox" v-model="someCheckboxValue" />
                    <Checkmark class="checkmark" />
                </CustomCheckbox>
                <CheckboxLabel>거래명세표</CheckboxLabel>
            </CheckboxGroup>

            <CheckboxGroup>
                <CustomCheckbox>
                    <input type="checkbox" v-model="someCheckboxValue" />
                    <Checkmark class="checkmark" />
                </CustomCheckbox>
                <CheckboxLabel>세금계산서</CheckboxLabel>
            </CheckboxGroup>

            <CheckboxGroup>
                <CustomCheckbox>
                    <input type="checkbox" v-model="someCheckboxValue" />
                    <Checkmark class="checkmark" />
                </CustomCheckbox>
                <CheckboxLabel>견적서</CheckboxLabel>
            </CheckboxGroup>
        </CheckboxWrapper>

        <ButtonGroup>
            <SubmitButton>확인</SubmitButton>
            <CloseButton @click="closeModal">취소</CloseButton>
        </ButtonGroup>
    </ModalContent>
</template>

<script>
import * as FaxModalCss from '@/assets/styles/order/modal/FaxModalCss.js';

export default {
    name: 'FaxModal',

    components: {
        ...FaxModalCss
    },

    data() {
        return {
            senderNumber: '선택',
            faxNumber: '',
            faxTitle: '',
        }
    },

    methods: {
        closeModal() {
            this.$emit('close');
        }
    }
}
</script>
